import { useCustomerStore } from 'src/stores/customer'
import { useAuthStore } from 'src/stores/auth'
import { usePersistedStore } from 'src/stores/persisted'
import { useCommonStore } from 'src/stores/common'
import { mapState } from 'pinia'

export default async ({ app, store }) => {
  app.mixin({
    data: function () {
      return {
        logoutInitiated: false,
      }
    },
    computed: {
      ...mapState(usePersistedStore, [
        'currentLocationId',
        'currentLocation',
        'selectedFulfillment',
        'selectedFulfillmentCodeName',
      ]),
      ...mapState(useCommonStore, [
        'businessFulfillments',
        'businessConfigurations',
        'commonStateByKey',
      ]),
      ...mapState(useAuthStore, [
        'customerExists',
        'isLoggedIn',
        'currentUser',
      ]),
      ...mapState(useCustomerStore, ['customer']),
    },
    methods: {
      scrollToPosition(scrollArea = null, position = 0, delay = 0) {
        if (scrollArea)
          scrollArea.setScrollPosition('vertical', position, delay)
      },
      applyBack() {
        const commonStore = useCommonStore()
        let route = {
          name: 'Home',
        }
        if (commonStore.backRoute) {
          const { name, params = {}, query = {} } = commonStore.backRoute
          route = { name, params, query }
        }
        this.$router.push(route).catch(() => {})
      },
      async loginWithIdentity(isSignup = false, signupAcr = '') {
        const authStore = useAuthStore()
        authStore
          .signIn({
            isSignup,
            signupAcr,
          })
          .then((user) => {
            if (this.$q.platform.is?.cordova && user) {
              this.$router.push({ name: 'Callback' })
            }
          })
          .catch((error) => {})
      },
      async performLogout(removeLnsToken = true) {
        const authStore = useAuthStore()
        const commonStore = useCommonStore()
        if (this.logoutInitiated) return

        this.logoutInitiated = true
        if (this.$q.platform.is?.cordova) {
          await authStore
            .deleteFCMToken(device.uuid)
            .then((response) => response)
            .catch((error) => error)
            .finally(() => {
              authStore.logout()
            })
        } else if (commonStore.lnsLoaded && removeLnsToken) {
          this.emitter.emit('remove-lns-firebase-token')
          // setTimeout(() => {
          //   authStore.logout()
          // }, 5000)
        } else authStore.logout()
      },
    },
  })
}
